<div class="clearfix"></div>
<div class="row border border-primary border-top-0 border-left-0 border-right-0" style="margin-bottom: 1px" *ngFor="let event_obj of events; let i = index">
  <h4 *ngIf="lastDatePosition != event_obj.date_position || i == 0" class="p-2">{{ setLastDatePosition(event_obj.date_position) }}</h4>
  <div class="col-12 p-2" [ngStyle]="{ 'border-left': '5px solid ' + event_obj.color }">
    <a (click)="toggleEvent(event_obj)" href="javascript: void(0)" title="View event">
      <i class="fas" [ngClass]="{ 'fa-plus-circle': !event_obj.expanded, 'fa-minus-circle': event_obj.expanded }"></i>
    </a>
    <div class="d-inline-block" style="width: 120px">{{ event_obj.event_title }}</div>
    <span [style.color]="event_obj.color">{{ event_obj.display_name }}</span>
    &nbsp;
    {{ event_obj.event_type_name }}
    <span *ngIf="agnostic && event_obj.intranet_name" class="badge badge-secondary ml-1">{{ event_obj.intranet_name }}</span>
    <span *ngIf="event_obj.title">&nbsp;{{ event_obj.title }}</span>
    <span *ngIf="event_obj.recurring">&nbsp;<i class="fas fa-repeat"></i></span>
    <a *ngIf="!agnostic" [routerLink]="'/events/'" [queryParams]="{ show_event_id: event_obj.id }" title="View event"><i class="fas fa-link"></i></a>
    <a *ngIf="agnostic" href="javascript:void(0)" (click)="openEvent(event_obj)" title="View event"><i class="fas fa-link"></i></a>
    <div class="clearfix"></div>
    <div class="float-left">
      <a *ngIf="!agnostic" target="_blank" [routerLink]="'/matters/' + event_obj.matter_id">{{ event_obj.matter_name }}</a>
      <a *ngIf="agnostic" href="javascript:void(0)" (click)="openMatter(event_obj)">{{ event_obj.matter_name }}</a>
    </div>
    <div class="clearfix"></div>
    <app-event [event_id]="event_obj.event_id || event_obj.id" *ngIf="event_obj.expanded"></app-event>
  </div>
</div>
